import React, { useState } from 'react';
import { Alert, AlertTitle, Button, Stack, Box } from '@mui/material';
import { gql, useQuery } from '@apollo/client';
import { useNavigate } from 'react-router-dom';
import { RouteTo } from '@routing/RouteMap';
import { useSubscriptionAccess } from '@company/hooks/useSubscriptionAccess';
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';
import CloseIcon from '@mui/icons-material/Close';

const GET_ONBOARDING_DRAFT = gql`
  query OnboardingDraft($category: String!) {
    draftState(category: $category) {
      updatedAt
    }
  }
`;

const STORAGE_KEY = 'onboardingBannerDismissed';

const OnboardingContinuationBanner: React.FC = () => {
  const navigate = useNavigate();
  const { hasAccess, loading: subscriptionLoading } = useSubscriptionAccess();
  const [isDismissed, setIsDismissed] = useState(() => localStorage.getItem(STORAGE_KEY) === 'true');

  const { data, loading } = useQuery(GET_ONBOARDING_DRAFT, {
    variables: { category: 'ONBOARDING' },
    skip: isDismissed, // skip if permanently dismissed
    fetchPolicy: 'network-only', // always fresh status
    errorPolicy: 'ignore',
  });

  const hasDraft = !!data?.draftState;

  if (loading || subscriptionLoading || hasAccess || isDismissed || !hasDraft) {
    return null;
  }

  const handleContinue = () => {
    navigate(RouteTo.ONBOARDING);
  };

  const handleDismiss = () => {
    setIsDismissed(true);
  };

  const handleDismissPermanently = () => {
    localStorage.setItem(STORAGE_KEY, 'true');
    setIsDismissed(true);
  };

  return (
    <Alert
      severity="info"
      icon={<RocketLaunchIcon />}
      action={
        <Button size="small" onClick={handleDismiss} sx={{ minWidth: 'auto', p: 0.5 }}>
          <CloseIcon fontSize="small" />
        </Button>
      }
      sx={{ mb: 2, '& .MuiAlert-action': { alignItems: 'flex-start', pt: 0 } }}
    >
      <AlertTitle>Onboarding fortsetzen</AlertTitle>
      <Box sx={{ mb: 1 }}>Du hast Dein Onboarding noch nicht abgeschlossen. Möchtest Du fortfahren?</Box>
      <Stack direction="row" spacing={1} sx={{ mt: 2 }}>
        <Button size="small" variant="contained" onClick={handleContinue}>
          Weiter zum Onboarding
        </Button>
        <Button size="small" variant="outlined" onClick={handleDismissPermanently}>
          Nicht mehr anzeigen
        </Button>
      </Stack>
    </Alert>
  );
};

export default OnboardingContinuationBanner; 